import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Output,
} from '@angular/core';
import { Observable, map, withLatestFrom } from 'rxjs';
import { BasisBestPriceMobilePriceOptionsComponent } from './basis-best-price-mobile-price-options.component';
import { CommonModule } from '@angular/common';
import { MOBILE_OVERLAY_DATA_TOKEN } from '@prlw/libs/mobile-overlay/mobile-overlay.service';
import {
  BasisBestPriceMobilePriceOptionsService,
  EDisplayPriceTariffOption,
} from '@prlw/core/monitor/basis-best-price-mobile-price-options.service';

export type TBestPriceMobilePriceOptionsItem = {
  dealTariffPrice: number | null;
  buyTariffPrice: number | null;
  sellTariffPrice: number | null;
};

@Component({
  selector: 'prlw-basis-best-price-mobile-price-options',
  standalone: true,
  imports: [CommonModule, BasisBestPriceMobilePriceOptionsComponent],
  templateUrl: './basis-best-price-mobile-price-options.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisBestPriceMobilePriceOptionsContainer {
  @Output() eventClose = new EventEmitter<void>();

  constructor(
    @Inject(MOBILE_OVERLAY_DATA_TOKEN)
    private readonly param$: Observable<TBestPriceMobilePriceOptionsItem>,
    private readonly service: BasisBestPriceMobilePriceOptionsService,
  ) {}

  items$ = this.service.current$.pipe(
    withLatestFrom(this.param$),
    map(([current, param]) =>
      [
        {
          id: EDisplayPriceTariffOption.DEAL,
          text: 'Сделка + тариф',
          value: param.dealTariffPrice,
        },
        {
          id: EDisplayPriceTariffOption.BUY,
          text: 'Спрос + тариф',
          value: param.buyTariffPrice,
        },
        {
          id: EDisplayPriceTariffOption.SELL,
          text: 'Предложение + тариф',
          value: param.sellTariffPrice,
        },
      ]
        .filter((item) => !!item.value)
        .map((item) => ({
          ...item,
          checked: item.id === current,
        })),
    ),
  );

  handleClick(id: EDisplayPriceTariffOption) {
    this.service.update(id);
  }
}
